import { memo } from "react";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import type { LabelProps } from "./types";

const Label = ({ sx, title, children }: LabelProps) => (
    <Box
        sx={{
            display: 'grid',
            ...sx
        }}
    >
        <Box>{title}</Box>
        <Typography
            variant='subtitle2'
        >
            {children}
        </Typography>
    </Box>
);

export default memo(Label);
